import React from "react";
import LobbyModal from "./LobbyModal";
import {
  goToFullTeamMultiplayerBattle,
  goToOpenBattle
} from "./get-home-menu-options";
import LobbyCTA from "./LobbyCTA";

class CrewHomeInviteModal extends React.Component {
  render() {
    return (
      <LobbyModal
        title="Choose Battle Type"
        handleCloseCallback={this.props.handleCloseCallback}
      >
        <div>
          <div>
            <h3 className="Modal__title">Versus Battle</h3>
            <p className="Modal__paragraph">
              Face off against one friend, each person controlling a Crew of
              three combatants.
            </p>
            <div className="Modal__btn-container--spaced">
              <LobbyCTA
                text="Start Versus"
                handler={goToFullTeamMultiplayerBattle}
                isPrimary={false}
              />
            </div>
          </div>
          <div>
            <h3 className="Modal__title">Rally Battle</h3>
            <p className="Modal__paragraph">
              Control one combatant in a battle of up to six players.
            </p>
            <div>
              <LobbyCTA
                text="Start Rally"
                handler={goToOpenBattle}
                isPrimary={false}
              />
            </div>
          </div>
        </div>
      </LobbyModal>
    );
  }
}

export default CrewHomeInviteModal;



// WEBPACK FOOTER //
// ./src/b5-home/CrewHomeInviteModal.js